import type {PanelBottomPill} from '@Components/panel/components/panel-bottom-pills';
import {PanelFooter, PanelFooterPrimaryDefaultAction} from '@Components/panel';
import type {ReactElement} from 'react';
import React from 'react';
import {getSelectedGridItems} from '@Components/base-grid';
import type {StockPrimaryCTA} from '@Panels/stock-panel/stock-panel.types';
import {StockPanelTabs} from '@Panels/stock-panel/stock-panel.types';
import {getBottomPills} from '@Panels/stock-panel/stock-panel.library';
import {useAppSelector} from '@/hooks';

export interface StockPanelFooterProps {
  selectionGroupID: string;
  bottomPillItems?: PanelBottomPill[];
  onPrimaryAction: StockPrimaryCTA;
  makeBottomPillsScrollable: boolean;
  isMobile?: boolean;
}

const ALL_PILLS_LENGTH = getBottomPills(StockPanelTabs.ALL, () => {}).length;

export default function StockPanelFooter({isMobile = false, ...props}: StockPanelFooterProps): ReactElement<any> {
  const selectedItems = useAppSelector((state) => {
    return getSelectedGridItems(state, props.selectionGroupID);
  });

  const primaryAction = [
    <PanelFooterPrimaryDefaultAction
      key="stock-btn-cta-footer"
      text={window.i18next.t('pmwjs_add_selected')}
      onClick={(): void => {
        void props.onPrimaryAction(selectedItems);
      }}
    />,
  ];

  const getPrimaryAction = (): ReactElement<any>[] | undefined => {
    if (selectedItems.length > 0) {
      return primaryAction;
    }

    return undefined;
  };

  return (
    <PanelFooter
      key={props.selectionGroupID}
      bottomPills={props.bottomPillItems}
      isScrollable={props.bottomPillItems && props.makeBottomPillsScrollable && props.bottomPillItems.length >= ALL_PILLS_LENGTH}
      className=""
      primaryActionsClassName=""
      primaryActions={getPrimaryAction()}
      border
      fullWidthPrimaryActions={isMobile}
    />
  );
}
